import { ContadorDiasResult } from "../Contador-dias";
export const ContadorTable = ({
    results
}: {
    results: ContadorDiasResult
}) => {
    return (
        <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
            <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
                <thead className="bg-gray-200 sticky top-0">
                    <tr>
                        <th className="px-4 py-2 text-center truncate">Evento</th>
                        <th className="px-4 py-2 text-center truncate">Valores</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Quantidade de dias
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.Dias}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Dia da semana
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.diaSemana}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Quantidade de semanas
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.Semana}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Quantidade de Meses
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.Mes}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Quantidade de Anos
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.Ano}
                        </td>
                    </tr>


                </tbody>
            </table>

        </div >
    )
}